import { ShippingFilter } from '../../component/filter/ShippingFilter';
import { Header } from '../../component/header/Header';
import { ShippingFilterColorType } from '../../type/common.type';

interface ProductOptionHeaderSectionProps {
  headerTitle: { display: boolean; actions: { resetSelectionModeNotification: () => void } };
  shippingFilterToggle: {
    display: boolean;
    checked: boolean;
    color_type: ShippingFilterColorType;
    actions: {
      handleClickShippingFilterToggle: () => void;
    };
  };
}

export const ProductOptionHeaderSection = ({ headerTitle, shippingFilterToggle }: ProductOptionHeaderSectionProps) => {
  return (
    <>
      {headerTitle.display && (
        <Header label='알림받을 옵션 선택' onClose={headerTitle.actions.resetSelectionModeNotification} />
      )}

      {shippingFilterToggle.display && (
        <ShippingFilter
          label='직진배송만 보기'
          checked={shippingFilterToggle.checked}
          color_type={shippingFilterToggle.color_type}
          handleClick={shippingFilterToggle.actions.handleClickShippingFilterToggle}
        />
      )}
    </>
  );
};
